var _defs, _g, _g2, _g3, _g4, _g5, _rect, _rect2, _g6, _g7, _polygon, _polygon2, _rect3, _rect4, _g8, _line, _rect5, _rect6, _g9, _rect7, _rect8, _g0, _rect9, _rect0, _g1, _line2, _path, _g10, _rect1, _rect10, _g11, _line3, _g12, _rect11, _rect12, _g13, _rect13, _rect14, _g14, _g15, _rect15, _rect16, _g16, _rect17, _rect18, _g17, _rect19, _rect20, _g18, _g19, _g20, _rect21, _rect22, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _rect23, _rect24, _g30, _rect25, _rect26, _g31, _rect27, _rect28, _g32, _g33, _rect29, _rect30, _g34, _g35, _rect31, _rect32, _g36, _g37, _rect33, _rect34, _g38, _rect35, _rect36, _g39, _rect37, _rect38, _g40, _rect39, _rect40, _g41, _rect41, _rect42, _g42, _g43, _rect43, _rect44, _g44, _g45, _rect45, _rect46, _g46, _rect47, _rect48, _g47, _rect49, _rect50, _g48, _g49, _rect51, _rect52, _g50, _rect53, _rect54, _g51, _rect55, _rect56, _g52, _rect57, _rect58, _g53, _rect59, _rect60, _g54, _rect61, _rect62, _g55, _rect63, _rect64, _g56, _rect65, _rect66, _g57, _rect67, _rect68, _g58, _rect69, _rect70, _g59, _rect71, _rect72, _g60, _rect73, _rect74, _g61, _rect75, _rect76, _g62, _rect77, _rect78, _g63, _polygon3, _polygon4, _rect79, _rect80, _g64, _g65, _path2, _path3, _path4, _path5, _path6, _g66, _line4, _g67, _g68, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g69, _path30, _path31, _path32, _path33;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrgchart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 619.16 493.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath-51);\n      }\n\n      .cls-2 {\n        letter-spacing: 0em;\n      }\n\n      .cls-3 {\n        letter-spacing: 0em;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-34);\n      }\n\n      .cls-5 {\n        letter-spacing: 0em;\n      }\n\n      .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\n        font-family: Calibri-Bold, Calibri;\n        font-weight: 700;\n      }\n\n      .cls-6, .cls-10 {\n        font-size: 4.42px;\n      }\n\n      .cls-12 {\n        letter-spacing: 0em;\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-38);\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-21);\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath-31);\n      }\n\n      .cls-19 {\n        letter-spacing: 0em;\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-33);\n      }\n\n      .cls-22 {\n        clip-path: url(#clippath-61);\n      }\n\n      .cls-23 {\n        clip-path: url(#clippath-18);\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath-47);\n      }\n\n      .cls-25 {\n        letter-spacing: 0em;\n      }\n\n      .cls-26 {\n        stroke: #1f497d;\n        stroke-width: 1.2px;\n      }\n\n      .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31 {\n        fill: none;\n      }\n\n      .cls-26, .cls-27, .cls-29, .cls-30 {\n        stroke-linejoin: round;\n      }\n\n      .cls-32 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-33 {\n        letter-spacing: 0em;\n      }\n\n      .cls-34 {\n        letter-spacing: 0em;\n      }\n\n      .cls-35 {\n        letter-spacing: 0em;\n      }\n\n      .cls-36 {\n        letter-spacing: 0em;\n      }\n\n      .cls-37 {\n        clip-path: url(#clippath-22);\n      }\n\n      .cls-38 {\n        letter-spacing: 0em;\n      }\n\n      .cls-39 {\n        letter-spacing: 0em;\n      }\n\n      .cls-40 {\n        clip-path: url(#clippath-23);\n      }\n\n      .cls-41 {\n        letter-spacing: 0em;\n      }\n\n      .cls-42 {\n        letter-spacing: 0em;\n      }\n\n      .cls-43 {\n        letter-spacing: 0em;\n      }\n\n      .cls-44 {\n        letter-spacing: 0em;\n      }\n\n      .cls-45 {\n        letter-spacing: 0em;\n      }\n\n      .cls-46 {\n        clip-path: url(#clippath-54);\n      }\n\n      .cls-47 {\n        clip-path: url(#clippath-66);\n      }\n\n      .cls-48 {\n        letter-spacing: 0em;\n      }\n\n      .cls-49 {\n        letter-spacing: 0em;\n      }\n\n      .cls-50 {\n        letter-spacing: 0em;\n      }\n\n      .cls-51 {\n        letter-spacing: 0em;\n      }\n\n      .cls-52 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-53 {\n        letter-spacing: 0em;\n      }\n\n      .cls-54 {\n        clip-path: url(#clippath-70);\n      }\n\n      .cls-55 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-7 {\n        font-size: 6.38px;\n      }\n\n      .cls-56 {\n        letter-spacing: 0em;\n      }\n\n      .cls-57 {\n        letter-spacing: .01em;\n      }\n\n      .cls-58 {\n        clip-path: url(#clippath-42);\n      }\n\n      .cls-59 {\n        clip-path: url(#clippath-59);\n      }\n\n      .cls-60, .cls-61 {\n        fill: #fff;\n      }\n\n      .cls-62 {\n        clip-path: url(#clippath-43);\n      }\n\n      .cls-63 {\n        clip-path: url(#clippath-64);\n      }\n\n      .cls-64 {\n        clip-path: url(#clippath-25);\n      }\n\n      .cls-65 {\n        clip-path: url(#clippath-27);\n      }\n\n      .cls-66 {\n        letter-spacing: 0em;\n      }\n\n      .cls-27 {\n        stroke: #385d8a;\n      }\n\n      .cls-27, .cls-29 {\n        stroke-width: .8px;\n      }\n\n      .cls-67 {\n        letter-spacing: 0em;\n      }\n\n      .cls-68 {\n        letter-spacing: 0em;\n      }\n\n      .cls-69 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-70 {\n        clip-path: url(#clippath-60);\n      }\n\n      .cls-8, .cls-61 {\n        font-size: 4.44px;\n      }\n\n      .cls-71 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-72 {\n        clip-path: url(#clippath-57);\n      }\n\n      .cls-73 {\n        letter-spacing: 0em;\n      }\n\n      .cls-74 {\n        letter-spacing: 0em;\n      }\n\n      .cls-75 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-76 {\n        clip-path: url(#clippath-36);\n      }\n\n      .cls-77 {\n        clip-path: url(#clippath-35);\n      }\n\n      .cls-78 {\n        clip-path: url(#clippath-48);\n      }\n\n      .cls-79 {\n        letter-spacing: 0em;\n      }\n\n      .cls-80 {\n        clip-path: url(#clippath-28);\n      }\n\n      .cls-81 {\n        fill: #1f497d;\n      }\n\n      .cls-82 {\n        letter-spacing: 0em;\n      }\n\n      .cls-83 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-84 {\n        clip-path: url(#clippath-56);\n      }\n\n      .cls-85 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-86 {\n        letter-spacing: 0em;\n      }\n\n      .cls-87 {\n        letter-spacing: 0em;\n      }\n\n      .cls-88 {\n        letter-spacing: 0em;\n      }\n\n      .cls-89 {\n        letter-spacing: 0em;\n      }\n\n      .cls-90 {\n        clip-path: url(#clippath-45);\n      }\n\n      .cls-91 {\n        clip-path: url(#clippath-46);\n      }\n\n      .cls-92 {\n        clip-path: url(#clippath-40);\n      }\n\n      .cls-93 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-94 {\n        clip-path: url(#clippath-20);\n      }\n\n      .cls-95 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-96 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-97 {\n        letter-spacing: 0em;\n      }\n\n      .cls-98 {\n        letter-spacing: 0em;\n      }\n\n      .cls-99 {\n        letter-spacing: 0em;\n      }\n\n      .cls-9 {\n        font-size: 4.8px;\n      }\n\n      .cls-100 {\n        clip-path: url(#clippath-52);\n      }\n\n      .cls-101 {\n        clip-path: url(#clippath-41);\n      }\n\n      .cls-102 {\n        letter-spacing: 0em;\n      }\n\n      .cls-103 {\n        clip-path: url(#clippath-67);\n      }\n\n      .cls-104 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-105 {\n        letter-spacing: 0em;\n      }\n\n      .cls-106 {\n        letter-spacing: 0em;\n      }\n\n      .cls-107 {\n        letter-spacing: 0em;\n      }\n\n      .cls-108 {\n        letter-spacing: .01em;\n      }\n\n      .cls-109 {\n        clip-path: url(#clippath-26);\n      }\n\n      .cls-110 {\n        letter-spacing: 0em;\n      }\n\n      .cls-111 {\n        letter-spacing: 0em;\n      }\n\n      .cls-61 {\n        font-family: Calibri, Calibri;\n      }\n\n      .cls-112 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-113 {\n        clip-path: url(#clippath-50);\n      }\n\n      .cls-114 {\n        letter-spacing: 0em;\n      }\n\n      .cls-115 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-116 {\n        letter-spacing: 0em;\n      }\n\n      .cls-117 {\n        letter-spacing: 0em;\n      }\n\n      .cls-118 {\n        letter-spacing: 0em;\n      }\n\n      .cls-119 {\n        letter-spacing: 0em;\n      }\n\n      .cls-120 {\n        fill: #06c;\n        fill-rule: evenodd;\n      }\n\n      .cls-121 {\n        clip-path: url(#clippath-30);\n      }\n\n      .cls-122 {\n        letter-spacing: 0em;\n      }\n\n      .cls-123 {\n        clip-path: url(#clippath-19);\n      }\n\n      .cls-124 {\n        letter-spacing: 0em;\n      }\n\n      .cls-125 {\n        letter-spacing: 0em;\n      }\n\n      .cls-126 {\n        letter-spacing: 0em;\n      }\n\n      .cls-127 {\n        letter-spacing: 0em;\n      }\n\n      .cls-128 {\n        clip-path: url(#clippath-32);\n      }\n\n      .cls-129 {\n        letter-spacing: 0em;\n      }\n\n      .cls-130 {\n        letter-spacing: 0em;\n      }\n\n      .cls-131 {\n        letter-spacing: 0em;\n      }\n\n      .cls-132 {\n        letter-spacing: 0em;\n      }\n\n      .cls-133 {\n        letter-spacing: 0em;\n      }\n\n      .cls-134 {\n        clip-path: url(#clippath-55);\n      }\n\n      .cls-135 {\n        letter-spacing: 0em;\n      }\n\n      .cls-136 {\n        letter-spacing: 0em;\n      }\n\n      .cls-137 {\n        letter-spacing: 0em;\n      }\n\n      .cls-138 {\n        clip-path: url(#clippath-53);\n      }\n\n      .cls-139 {\n        clip-path: url(#clippath-39);\n      }\n\n      .cls-140 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-29, .cls-31 {\n        stroke: #000;\n      }\n\n      .cls-141 {\n        letter-spacing: 0em;\n      }\n\n      .cls-142 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-143 {\n        letter-spacing: 0em;\n      }\n\n      .cls-144 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-145 {\n        clip-path: url(#clippath-29);\n      }\n\n      .cls-146 {\n        letter-spacing: .02em;\n      }\n\n      .cls-147 {\n        letter-spacing: 0em;\n      }\n\n      .cls-148 {\n        letter-spacing: 0em;\n      }\n\n      .cls-149 {\n        clip-path: url(#clippath-49);\n      }\n\n      .cls-150 {\n        clip-path: url(#clippath-37);\n      }\n\n      .cls-151 {\n        letter-spacing: 0em;\n      }\n\n      .cls-10 {\n        letter-spacing: 0em;\n      }\n\n      .cls-152 {\n        clip-path: url(#clippath-58);\n      }\n\n      .cls-153 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-154 {\n        letter-spacing: 0em;\n      }\n\n      .cls-155 {\n        letter-spacing: 0em;\n      }\n\n      .cls-156 {\n        letter-spacing: 0em;\n      }\n\n      .cls-157 {\n        letter-spacing: 0em;\n      }\n\n      .cls-158 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-30 {\n        stroke: #4a7ebb;\n      }\n\n      .cls-30, .cls-31 {\n        stroke-width: .3px;\n      }\n\n      .cls-31 {\n        stroke-miterlimit: 8;\n      }\n\n      .cls-159 {\n        letter-spacing: 0em;\n      }\n\n      .cls-160 {\n        letter-spacing: 0em;\n      }\n\n      .cls-161 {\n        clip-path: url(#clippath-63);\n      }\n\n      .cls-162 {\n        clip-path: url(#clippath-24);\n      }\n\n      .cls-11 {\n        font-size: 3.98px;\n      }\n\n      .cls-163 {\n        letter-spacing: 0em;\n      }\n\n      .cls-164 {\n        letter-spacing: 0em;\n      }\n\n      .cls-165 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-166 {\n        letter-spacing: 0em;\n      }\n\n      .cls-167 {\n        letter-spacing: 0em;\n      }\n\n      .cls-168 {\n        clip-path: url(#clippath-68);\n      }\n\n      .cls-169 {\n        letter-spacing: 0em;\n      }\n\n      .cls-170 {\n        letter-spacing: 0em;\n      }\n\n      .cls-171 {\n        clip-path: url(#clippath-65);\n      }\n\n      .cls-172 {\n        clip-path: url(#clippath-44);\n      }\n\n      .cls-173 {\n        letter-spacing: 0em;\n      }\n\n      .cls-174 {\n        letter-spacing: 0em;\n      }\n\n      .cls-175 {\n        clip-path: url(#clippath-62);\n      }\n\n      .cls-176 {\n        clip-path: url(#clippath-69);\n      }\n\n      .cls-177 {\n        letter-spacing: 0em;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    y: 122.81,
    width: 619.27,
    height: 4.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 371.57,
    y: 157.37,
    width: 40.32,
    height: 4.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 412.85,
    y: 157.37,
    width: 40.32,
    height: 4.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    y: 180.41,
    width: 619.27,
    height: 4.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    y: 261.07,
    width: 619.27,
    height: 4.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-56"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-57"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-58"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-59"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-60"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-61"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-62"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-63"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-64"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-66"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-67"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-68"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-69"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-70"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.98,
    y: 6.6,
    width: 620.16,
    height: 479.04
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-165"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-61",
    transform: "translate(19.68 126.89)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-158",
    x: 2.04,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 4.56,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-163",
    x: 6.73,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.81,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-163",
    x: 10.68,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-108",
    x: 13.21,
    y: 0
  }, "LM"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-167",
    x: 18.96,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 21.49,
    y: 0
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-61",
    transform: "translate(389.33 161.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-124",
    x: 0,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 2.77,
    y: 0
  }, "\xDC"), /*#__PURE__*/React.createElement("tspan", {
    x: 5.64,
    y: 0
  }, "VEN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 13.19,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-66",
    x: 15.11,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-82",
    x: 16.2,
    y: 0
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-167",
    x: 18.48,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 19.44,
    y: 0
  }, "H"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-154",
    x: 22.21,
    y: 0
  }, "\u0130Z"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.33,
    y: 0
  }, ".")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-144"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-61",
    transform: "translate(409.97 161.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-124",
    x: 0,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 2.77,
    y: 0
  }, "\xDC"), /*#__PURE__*/React.createElement("tspan", {
    x: 5.64,
    y: 0
  }, "VEN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 13.19,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-66",
    x: 15.11,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-82",
    x: 16.2,
    y: 0
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-167",
    x: 18.48,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 19.44,
    y: 0
  }, "H"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-154",
    x: 22.21,
    y: 0
  }, "\u0130Z"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.33,
    y: 0
  }, ".")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-104"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-61",
    transform: "translate(46.08 184.49)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-158",
    x: 2.04,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-124",
    x: 4.56,
    y: 0
  }, "\u011E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-108",
    x: 7.33,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-163",
    x: 9.24,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-156",
    x: 10.32,
    y: 0
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-158",
    x: 12.61,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-127",
    x: 13.57,
    y: 0
  }, "B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-158",
    x: 15.97,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-156",
    x: 18.5,
    y: 0
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-163",
    x: 20.78,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-48",
    x: 21.87,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-158",
    x: 25.7,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 26.66,
    y: 0
  }, "H"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-154",
    x: 29.43,
    y: 0
  }, "\u0130Z. "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 34.59,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 38.43,
    y: 0
  }, "\xDCD\xDC"), /*#__PURE__*/React.createElement("tspan", {
    x: 46.94,
    y: 0
  }, "R\xDC")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-61",
    transform: "translate(48.24 265.15)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FTR")))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 143.5,
    y: 44.18,
    width: 218.94,
    height: 16.08
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 143.5,
    y: 44.18,
    width: 218.94,
    height: 16.08
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-93"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(215.74 54.46)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Y\xD6NE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 14.95,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-160",
    x: 18.13,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.81,
    y: 0
  }, "M")))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(242.67 54.46)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 3.49,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-73",
    x: 7.67,
    y: 0
  }, "RULU "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-157",
    x: 23.74,
    y: 0
  }, "B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 27.34,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.22,
    y: 0
  }, "\u015EK"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-53",
    x: 37.73,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.63,
    y: 0
  }, "NI")))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "261.07 71.71 262.69 71.71 262.69 60.21 265.93 60.21 265.93 71.71 267.55 71.71 264.31 74.95 261.07 71.71"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "261.07 71.71 262.69 71.71 262.69 60.21 265.93 60.21 265.93 71.71 267.55 71.71 264.31 74.95 261.07 71.71"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 193.27,
    y: 76.39,
    width: 142.22,
    height: 11.23
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 193.27,
    y: 76.39,
    width: 142.22,
    height: 11.23
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(259.04 84.24)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CEO")))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 192.59,
    y1: 110.33,
    x2: 39.47,
    y2: 110.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 215.72,
    y: 330.8,
    width: 72.34,
    height: 27.21
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 215.72,
    y: 330.8,
    width: 72.34,
    height: 27.21
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-96"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(239.4 346.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-164",
    x: 5.18,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-126",
    x: 7.57,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-117",
    x: 8.85,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-85",
    x: 12.03,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-170",
    x: 13.04,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 15.96,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-141",
    x: 17.98,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-117",
    x: 22.16,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.08,
    y: 0
  })))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 35.57,
    y: 181.86,
    width: 74.46,
    height: 23.04
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 35.57,
    y: 181.86,
    width: 74.46,
    height: 23.04
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(69.44 194.93)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FTR")))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 19.72,
    y: 118.96,
    width: 83.42,
    height: 23.46
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 19.72,
    y: 118.96,
    width: 83.42,
    height: 23.46
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(32.33 132.38)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-148",
    x: 5.18,
    y: 0
  }, "\u011E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-130",
    x: 8.25,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.27,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-99",
    x: 11.55,
    y: 0
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 14.19,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 15.25,
    y: 0
  }, "BA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-131",
    x: 20.85,
    y: 0
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-126",
    x: 23.5,
    y: 0
  }, "IM"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-151",
    x: 28.97,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 30.03,
    y: 0
  }, "H\u0130"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-148",
    x: 34.33,
    y: 0
  }, "Z"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.64,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 37.92,
    y: 0,
    xmlSpace: "preserve"
  }, " M\xDC"), /*#__PURE__*/React.createElement("tspan", {
    x: 46.29,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-130",
    x: 49.32,
    y: 0
  }, "\xDCR"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-126",
    x: 55.13,
    y: 0
  }, "\xDC")))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 83.84,
    y1: 134.47,
    x2: 80.91,
    y2: 134.76
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M31.75,159.87l4.46,2.67-4.52,2.57c-.29.16-.65.06-.82-.23-.16-.28-.06-.65.23-.81l3.62-2.07v1.04s-3.59-2.14-3.59-2.14c-.28-.17-.38-.54-.21-.82s.54-.38.83-.21ZM21.36,161.79l13.66.13v1.2s-13.67-.13-13.67-.13v-1.2Z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 19.28,
    y1: 472.79,
    x2: 20.6,
    y2: 143.27
  }))), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 499.56,
    y: 72.02,
    width: 73.28,
    height: 23.02
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 499.56,
    y: 72.02,
    width: 73.28,
    height: 23.02
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(530.04 85.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 0,
    y: 0
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 2.4,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 5.08,
    y: 0
  }, "L\u0130T"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.35,
    y: 0
  }, "E")))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 498.51,
    y1: 82.72,
    x2: 335.28,
    y2: 81.96
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M37.49,115.02l2.81,4.37,2.42-4.6c.15-.29.04-.66-.25-.81-.29-.16-.66-.04-.81.25l-1.94,3.69,1.03-.05-2.25-3.5c-.18-.28-.55-.36-.83-.18s-.36.55-.18.83ZM39.32,110.72l.33,7.5,1.2-.05-.33-7.5-1.2.05Z"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 35.58,
    y: 320.57,
    width: 78.18,
    height: 22.17
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 35.58,
    y: 320.57,
    width: 78.18,
    height: 22.17
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "cls-115"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(61.78 333.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 2.8,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    x: 5.76,
    y: 0
  }, "\u011E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-98",
    x: 8.59,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-154",
    x: 11.48,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-98",
    x: 15.32,
    y: 0
  }, "H"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.1,
    y: 0
  }, "ANE")))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 36.68,
    y: 151.02,
    width: 72.44,
    height: 25.55
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 36.68,
    y: 151.02,
    width: 72.44,
    height: 25.55
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(62.12 165.34)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 0,
    y: 0
  }, "AC\u0130"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.22,
    y: 0
  }, "L")))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "cls-142"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(71.14 165.34)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 0,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.06,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 4.22,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 6.71,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 9.31,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-169",
    x: 10.5,
    y: 0
  }, "S")))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 35.14,
    y: 211.13,
    width: 76.32,
    height: 20.53
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 35.14,
    y: 211.13,
    width: 76.32,
    height: 20.53
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(62.96 222.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 2.49,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 5.18,
    y: 0
  }, "DYOLO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 18.1,
    y: 0
  }, "J"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.53,
    y: 0
  }, "\u0130")))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 35.6,
    y: 238.09,
    width: 76.73,
    height: 21.95
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 35.6,
    y: 238.09,
    width: 76.73,
    height: 21.95
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(62.52 250.63)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ODYO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-137",
    x: 11.05,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.88,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 17.04,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-169",
    x: 19.24,
    y: 0
  }, "R\u0130")))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 36.37,
    y: 265.99,
    width: 77.38,
    height: 23.67
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 36.37,
    y: 265.99,
    width: 77.38,
    height: 23.67
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "cls-123"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(65.98 279.38)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 0,
    y: 0
  }, "YDY"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.4,
    y: 0
  }, "B")))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(75.87 279.38)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2013")))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(77.21 279.38)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "EYB")))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 35.6,
    y: 347.53,
    width: 79.53,
    height: 24.01
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 35.6,
    y: 347.53,
    width: 79.53,
    height: 24.01
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(53.07 361.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "EEG")))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(60.22 361.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2013")))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "cls-162"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(61.56 361.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 2.15,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 0
  }, "G")))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(70.4 361.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2013")))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "cls-109"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(71.74 361.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "EKG")))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(79.13 361.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2013")))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(80.48 361.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 0,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.06,
    y: 0
  }, "FT")))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(86.76 361.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2013")))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "cls-121"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(88.11 361.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "EF"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-111",
    x: 4.18,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-169",
    x: 7.15,
    y: 0
  }, "R")))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 34.72,
    y: 433.18,
    width: 83.16,
    height: 21.51
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 34.72,
    y: 433.18,
    width: 83.16,
    height: 21.51
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(62.31 445.54)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 1.87,
    y: 0
  }, "AB"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.04,
    y: 0
  }, "ORA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50",
    x: 15.19,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-105",
    x: 17.41,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 20.29,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    x: 22.88,
    y: 0
  }, "AR")))), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 34.38,
    y: 461.27,
    width: 83.97,
    height: 20.58
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 34.38,
    y: 461.27,
    width: 83.97,
    height: 20.58
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    className: "cls-128"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(66.82 473.16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 0,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.06,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 4.22,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 6.71,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 9.31,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 10.5,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.57,
    y: 0
  }, "LER")))), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 35.53,
    y: 378.64,
    width: 80.94,
    height: 22.98
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 35.53,
    y: 378.64,
    width: 80.94,
    height: 22.98
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(46.73 391.73)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AMEL"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 10.56,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.75,
    y: 0
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 14.05,
    y: 0
  }, "AT"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.94,
    y: 0
  }, "H"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 21.72,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 24.36,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-169",
    x: 27.28,
    y: 0
  }, "E")))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(77.04 391.73)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 0,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 2.06,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 4.26,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 6.42,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 8.91,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.11,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-143",
    x: 11.98,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.18,
    y: 0
  }, "ZASYON")))), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 365.56,
    y: 120.61,
    width: 68.28,
    height: 20.11
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 365.56,
    y: 120.61,
    width: 68.28,
    height: 20.11
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(384.32 132.34)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-79",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.39,
    y: 0
  }, "ES\u0130S")))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(395.93 132.34)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-141",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-130",
    x: 4.18,
    y: 0
  }, "\xDC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-68",
    x: 7.3,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-130",
    x: 10.33,
    y: 0
  }, "\xDCR"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.14,
    y: 0
  }, "\xDC")))), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 36.18,
    y: 293.01,
    width: 77.07,
    height: 25.05
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 36.18,
    y: 293.01,
    width: 77.07,
    height: 25.05
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(61.9 307.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "HA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-43",
    x: 5.46,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 7.54,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-105",
    x: 9.74,
    y: 0
  }, "A")))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(75.24 307.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-111",
    x: 0,
    y: 0
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.4,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50",
    x: 5.08,
    y: 0
  }, "B"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.58,
    y: 0
  }, "UL")))), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 35.53,
    y: 406.24,
    width: 81.91,
    height: 22.48
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 35.53,
    y: 406.24,
    width: 81.91,
    height: 22.48
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(64.16 419.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 0,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.06,
    y: 0
  }, "EKRE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 11.27,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.48,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-136",
    x: 15.63,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-105",
    x: 18.13,
    y: 0
  }, "LER")))), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 215.02,
    y: 392.15,
    width: 72.58,
    height: 24.65
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 215.02,
    y: 392.15,
    width: 72.58,
    height: 24.65
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(248.28 406.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 0,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-132",
    x: 1.19,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.26,
    y: 0
  }, "G")))), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 215.09,
    y: 206.19,
    width: 72.89,
    height: 24.28
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 215.09,
    y: 206.19,
    width: 72.89,
    height: 24.28
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(240.77 219.89)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 0,
    y: 0
  }, "B\u0130"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.68,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 5.55,
    y: 0
  }, "G\u0130"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-69",
    x: 9.56,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 10.43,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-132",
    x: 11.62,
    y: 0
  }, "\u015E"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.69,
    y: 0
  }, "LEM")))), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 215.64,
    y: 299.58,
    width: 71.96,
    height: 27.16
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 215.64,
    y: 299.58,
    width: 71.96,
    height: 27.16
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(234.08 314.59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-147",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 3.5,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 5.42,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.92,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-174",
    x: 8.98,
    y: 0
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 11.14,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.54,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-146",
    x: 15.22,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-147",
    x: 16.22,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 19.72,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-174",
    x: 22.32,
    y: 0
  }, "H"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 24.81,
    y: 0
  }, "AS"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 29.08,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-147",
    x: 31.01,
    y: 0
  }, "B"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.26,
    y: 0
  }, "E")))), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 215.04,
    y: 179.4,
    width: 72.11,
    height: 22.67
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 215.04,
    y: 179.4,
    width: 72.11,
    height: 22.67
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(228.39 192.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-111",
    x: 0,
    y: 0
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.4,
    y: 0
  }, "URU"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 10.65,
    y: 0
  }, "MS"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.57,
    y: 0
  }, "AL")))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    className: "cls-172"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(250.47 192.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PAZ"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 7.14,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.83,
    y: 0
  }, "RL"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 14.18,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 16.87,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.71,
    y: 0
  }, "A")))), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 215.19,
    y: 151.84,
    width: 71.95,
    height: 21.43
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 215.19,
    y: 151.84,
    width: 71.95,
    height: 21.43
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    className: "cls-90"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(241.13 164.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 0,
    y: 0
  }, "YAZ"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.11,
    y: 0
  }, "I")))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(250.35 164.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 0,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-132",
    x: 1.19,
    y: 0
  }, "\u015E"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.26,
    y: 0
  }, "LE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 7.28,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.78,
    y: 0
  }, "\u0130")))), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 215.28,
    y: 420.95,
    width: 72.32,
    height: 25.47
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 215.28,
    y: 420.95,
    width: 72.32,
    height: 25.47
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(245.96 435.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 2.68,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-132",
    x: 5.18,
    y: 0
  }, "\u015E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 7.25,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.44,
    y: 0
  }, "V")))), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 215.87,
    y: 269.14,
    width: 70.81,
    height: 26.28
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 215.87,
    y: 269.14,
    width: 70.81,
    height: 26.28
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(241.61 283.85)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 0,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-132",
    x: 1.19,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 3.26,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 5.46,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50",
    x: 8.14,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 10.35,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-132",
    x: 11.54,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 13.61,
    y: 0
  }, "T\u0130"), /*#__PURE__*/React.createElement("tspan", {
    x: 17,
    y: 0
  }, "K")))), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 215.46,
    y: 235.06,
    width: 72.61,
    height: 25.8
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 215.46,
    y: 235.06,
    width: 72.61,
    height: 25.8
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(237.08 249.53)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "HA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-43",
    x: 5.46,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 7.54,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-105",
    x: 9.74,
    y: 0
  }, "A")))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    className: "cls-113"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(250.42 249.53)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "HAKLA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 12.42,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.92,
    y: 0
  }, "I")))), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 215.46,
    y: 126.37,
    width: 71.69,
    height: 22.22
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 215.46,
    y: 126.37,
    width: 71.69,
    height: 22.22
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(225.48 139.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.84,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-111",
    x: 6,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.07,
    y: 0
  }, "UL"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-88",
    x: 12.82,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-107",
    x: 13.78,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.62,
    y: 0
  }, "\xDCD\xDCR"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 28.66,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 29.62,
    y: 0
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 31.91,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.6,
    y: 0
  }, "RD"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50",
    x: 39.87,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 41.08,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 44.92,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 47.26,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 48.46,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 50.52,
    y: 0
  }, "I")))), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 380.43,
    y: 287.92,
    width: 65.36,
    height: 23.19
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 380.43,
    y: 287.92,
    width: 65.36,
    height: 23.19
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    className: "cls-100"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(404.69 301.08)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.2,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-110",
    x: 4.35,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 8.2,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-173",
    x: 9.4,
    y: 0
  }, "ZL"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-143",
    x: 13.37,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.57,
    y: 0
  }, "K")))), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 380.09,
    y: 231.66,
    width: 64.82,
    height: 21.85
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 380.09,
    y: 231.66,
    width: 64.82,
    height: 21.85
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(406.28 244.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 0,
    y: 0
  }, "\u015EO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-155",
    x: 5.04,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-102",
    x: 7.06,
    y: 0
  }, "\xD6"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.04,
    y: 0
  }, "R")))), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 380.89,
    y: 201.67,
    width: 62.6,
    height: 23.04
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 380.89,
    y: 201.67,
    width: 62.6,
    height: 23.04
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(402.8 214.73)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-122",
    x: 2.83,
    y: 0
  }, "\xDC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 5.71,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.31,
    y: 0
  }, "ENL\u0130K")))), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 380.63,
    y: 316.79,
    width: 66.08,
    height: 23.89
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 380.63,
    y: 316.79,
    width: 66.08,
    height: 23.89
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(407.69 330.31)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-107",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.84,
    y: 0
  }, "ORG")))), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 380.31,
    y: 145.53,
    width: 61.79,
    height: 22.77
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 380.31,
    y: 145.53,
    width: 61.79,
    height: 22.77
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    className: "cls-84"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(397.85 158.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.2,
    y: 0
  }, "EKN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-135",
    x: 9.68,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 10.88,
    y: 0
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-95",
    x: 13.28,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 14.19,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.26,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 18.41,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-107",
    x: 20.91,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 23.5,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.7,
    y: 0
  }, "S")))), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 380.45,
    y: 174.05,
    width: 62.12,
    height: 22.26
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 380.45,
    y: 174.05,
    width: 62.12,
    height: 22.26
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(397.61 186.72)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xC7A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-154",
    x: 5.04,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.88,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-124",
    x: 11.57,
    y: 0
  }, "\u015E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-119",
    x: 13.63,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.83,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-155",
    x: 17.33,
    y: 0
  }, "H"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.11,
    y: 0
  }, "ANE")))), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 380.74,
    y: 259.27,
    width: 64.63,
    height: 23.04
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 380.74,
    y: 259.27,
    width: 64.63,
    height: 23.04
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    className: "cls-152"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(404.67 272.35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-159",
    x: 0,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.07,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50",
    x: 4.74,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 7.68,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.88,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 12.36,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.06,
    y: 0
  }, "L")))), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 379.97,
    y: 350.61,
    width: 69.03,
    height: 23.86
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 379.97,
    y: 350.61,
    width: 69.03,
    height: 23.86
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(409.42 364.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DEPO")))), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 525.24,
    y: 165.47,
    width: 71.96,
    height: 25.45
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 525.24,
    y: 165.47,
    width: 71.96,
    height: 25.45
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(549.72 179.74)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-166",
    x: 2.15,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    x: 5.08,
    y: 0
  }, "FE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-107",
    x: 9.26,
    y: 0
  }, "KS"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 13.73,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.92,
    y: 0
  }, "YON")))), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 525.13,
    y: 102.93,
    width: 71.62,
    height: 24.63
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 525.13,
    y: 102.93,
    width: 71.62,
    height: 24.63
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(554.31 116.78)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 2.15,
    y: 0
  }, "\u011E\u0130T\u0130"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.56,
    y: 0
  }, "M")))), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 214.94,
    y: 362.87,
    width: 72.66,
    height: 25.95
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 214.94,
    y: 362.87,
    width: 72.66,
    height: 25.95
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    className: "cls-175"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(244.13 377.42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 2.15,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 4.5,
    y: 0
  }, "ZA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 9.29,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-169",
    x: 12.23,
    y: 0
  }, "E")))), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 525.63,
    y: 133.32,
    width: 71.11,
    height: 25.5
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 525.63,
    y: 133.32,
    width: 71.11,
    height: 25.5
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(534.89 147.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 0,
    y: 0
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.41,
    y: 0
  }, "AL\u0130"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-119",
    x: 8.16,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.36,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 12.53,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 13.44,
    y: 0
  }, "B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-177",
    x: 15.93,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.12,
    y: 0
  }, "R\u0130"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 20.81,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-140",
    x: 24.66,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 25.52,
    y: 0
  }, "SO"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.56,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-155",
    x: 33.06,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-154",
    x: 35.94,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 39.78,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-82",
    x: 41.66,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.54,
    y: 0
  }, "LARI")))), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 525.13,
    y: 200.85,
    width: 72.07,
    height: 25.05
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 525.13,
    y: 200.85,
    width: 72.07,
    height: 25.05
  })), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(547.35 214.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 0,
    y: 0
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.4,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-67",
    x: 5.39,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 9.22,
    y: 0
  }, "\u0130"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-159",
    x: 10.41,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.48,
    y: 0
  }, "YO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 17.76,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.68,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 22.55,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.24,
    y: 0
  }, "R")))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "261.91 99.58 263.52 99.58 263.52 88.06 266.73 88.06 266.73 99.58 268.34 99.58 265.13 102.8 261.91 99.58"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "261.91 99.58 263.52 99.58 263.52 88.06 266.73 88.06 266.73 99.58 268.34 99.58 265.13 102.8 261.91 99.58"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 192.59,
    y: 101.69,
    width: 143.56,
    height: 15.3
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 192.59,
    y: 101.69,
    width: 143.56,
    height: 15.3
  })), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(243.63 111.58)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MESUL")))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(263.69 111.58)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M\xDCD\xDCR")))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M30.1,222.96l4.46,2.66-4.51,2.58c-.29.16-.66.06-.82-.23-.17-.29-.07-.65.22-.82l3.62-2.06v1.03s-3.59-2.13-3.59-2.13c-.28-.17-.38-.54-.21-.82.17-.29.54-.38.83-.21ZM19.67,224.88l13.71.13-.02,1.2-13.71-.13.02-1.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M30.55,246.42l4.46,2.66-4.51,2.57c-.29.17-.65.07-.82-.22-.16-.29-.06-.66.23-.82l3.61-2.07v1.04s-3.59-2.13-3.59-2.13c-.28-.17-.37-.54-.2-.83.17-.28.53-.37.82-.2ZM20.13,248.34l13.7.12v1.2s-13.71-.12-13.71-.12v-1.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M31.93,304.02l4.46,2.66-4.51,2.57c-.29.17-.65.07-.82-.22-.16-.29-.06-.66.23-.82l3.62-2.07v1.04s-3.59-2.13-3.59-2.13c-.29-.17-.38-.54-.21-.83.17-.28.54-.37.82-.2ZM21.5,305.94l13.71.12v1.2s-13.72-.12-13.72-.12v-1.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M31.93,274.44l4.46,2.66-4.51,2.58c-.29.16-.65.06-.82-.23-.16-.29-.06-.65.23-.82l3.62-2.06v1.04s-3.59-2.14-3.59-2.14c-.29-.17-.38-.54-.21-.82.17-.29.54-.38.82-.21ZM21.5,276.35l13.71.14v1.2s-13.72-.14-13.72-.14v-1.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M31.02,190.05l4.46,2.66-4.52,2.58c-.29.16-.65.06-.82-.23-.16-.29-.06-.65.23-.82l3.62-2.06v1.04s-3.59-2.14-3.59-2.14c-.28-.17-.38-.54-.21-.82.17-.29.54-.38.83-.21ZM20.58,191.96l13.71.14v1.2s-13.72-.14-13.72-.14v-1.2Z"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    className: "cls-103"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 205.42,
    y1: 432.47,
    x2: 206.34,
    y2: 116.46
  }))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 390.8,
    y1: 109.96,
    x2: 335.28,
    y2: 109.91
  })), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    className: "cls-168"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M388.45,115.43l2.82,4.36,2.41-4.6c.15-.29.04-.66-.25-.81-.3-.15-.66-.04-.81.25l-1.94,3.69,1.04-.04-2.26-3.5c-.18-.28-.56-.36-.83-.18-.28.18-.36.55-.18.83ZM390.2,109.53l.41,9.1,1.2-.05-.41-9.1-1.2.05Z"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    className: "cls-176"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 369.71,
    y1: 364.96,
    x2: 369.71,
    y2: 139.9
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M30.1,326.64l4.46,2.66-4.51,2.58c-.29.16-.66.06-.82-.23-.17-.29-.07-.65.22-.82l3.62-2.06v1.03s-3.59-2.13-3.59-2.13c-.28-.17-.38-.54-.21-.82.17-.29.54-.38.83-.21ZM19.67,328.56l13.71.13-.02,1.2-13.71-.13.02-1.2Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M30.1,355.44l4.46,2.66-4.51,2.58c-.29.16-.66.06-.82-.23-.17-.29-.07-.65.22-.82l3.62-2.06v1.03s-3.59-2.13-3.59-2.13c-.28-.17-.38-.54-.21-.82.17-.29.54-.38.83-.21ZM19.67,357.36l13.71.13-.02,1.2-13.71-.13.02-1.2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M30.1,384.24l4.46,2.66-4.51,2.58c-.29.16-.66.06-.82-.23-.17-.29-.07-.65.22-.82l3.62-2.06v1.03s-3.59-2.13-3.59-2.13c-.28-.17-.38-.54-.21-.82.17-.29.54-.38.83-.21ZM19.67,386.16l13.71.13-.02,1.2-13.71-.13.02-1.2Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M30.1,413.04l4.46,2.66-4.51,2.58c-.29.16-.66.06-.82-.23-.17-.29-.07-.65.22-.82l3.62-2.06v1.03s-3.59-2.13-3.59-2.13c-.28-.17-.38-.54-.21-.82.17-.29.54-.38.83-.21ZM19.67,414.96l13.71.13-.02,1.2-13.71-.13.02-1.2Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M30.1,436.08l4.46,2.66-4.51,2.58c-.29.16-.66.06-.82-.23-.17-.29-.07-.65.22-.82l3.62-2.06v1.03s-3.59-2.13-3.59-2.13c-.28-.17-.38-.54-.21-.82.17-.29.54-.38.83-.21ZM19.67,438l13.71.13-.02,1.2-13.71-.13.02-1.2Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M30.1,470.64l4.46,2.66-4.51,2.58c-.29.17-.66.07-.82-.22-.17-.29-.07-.65.22-.82l3.62-2.07v1.04s-3.59-2.13-3.59-2.13c-.28-.17-.38-.54-.21-.82.17-.28.54-.38.83-.21ZM19.67,472.56l13.71.13-.02,1.2-13.71-.13.02-1.2Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M210.6,309.29l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM205.42,311.28l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M210.6,280.49l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM205.42,282.48l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M210.6,245.93l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM205.42,247.92l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M210.6,217.13l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM205.42,219.12l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M210.6,188.33l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM205.42,190.32l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M210.6,159.53l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM205.42,161.52l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M210.6,136.49l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM205.42,138.48l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M210.6,338.09l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM205.42,340.08l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M210.6,372.65l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM205.42,374.64l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M210.6,401.45l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM205.42,403.44l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M210.6,430.25l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM205.42,432.24l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M375.72,153.77l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM370.54,155.76l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M375.72,182.57l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM370.54,184.56l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M375.72,211.37l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM370.54,213.36l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M375.72,240.17l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM370.54,242.16l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M375.72,268.97l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM370.54,270.96l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M375.72,297.77l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM370.54,299.76l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M375.72,326.57l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM370.54,328.56l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M375.72,361.13l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM370.54,363.12l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 514.19,
    y1: 215.2,
    x2: 514.19,
    y2: 95.06
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M520.2,113.45l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM515.02,115.44l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M520.2,142.25l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM515.02,144.24l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M520.2,176.81l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM515.02,178.8l8.46.04v1.2l-8.46-.04v-1.2Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M520.2,211.37l4.47,2.64-4.5,2.59c-.29.17-.66.07-.82-.22-.17-.28-.07-.65.22-.81l3.61-2.09v1.04s-3.59-2.12-3.59-2.12c-.29-.17-.38-.53-.22-.82.17-.29.54-.38.83-.21ZM515.02,213.36l8.46.04v1.2l-8.46-.04v-1.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgchart);
export default __webpack_public_path__ + "static/media/orgchart.f1a10c3af2fa4e88f9bae8f5492aec71.svg";
export { ForwardRef as ReactComponent };